import React, { memo } from 'react'
import notFound from "../../../assets/images/404-img.webp"
import "./accessdenied.scss"
import { Container, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1); // Goes back one page in history
  };
  return (
    <Container sx={{ maxWidth: "1280px" }} >
      <Grid container spacing={2} className="container-notfound" >
        <Grid size={{ xs: 12, sm: 12, md: 12, }}>
          <div className='image-container'>
            <div>
              <img src={notFound} alt='Not Found' />
            </div>
          </div>
          <div className='blinking-red text-center h3'>Warning !!!</div>
          <div className='page-content text-center'>  Access to the dashboard has been restricted because developer tools are currently open. <br />Please close them and to continue <span className='see-link' onClick={handleGoBack}>clickhere</span> after closing developer tools. </div>
        </Grid>
      </Grid>
    </Container>
  )
}
export default memo(NotFound)